<template>
  <div class="contact-thanks">
      <div class="mail-sent-img">
          <img src="@/assets/img/mail-sent.svg" alt="">
      </div>

      <h1 class="about-h1">{{name}}, thanks for your interest!</h1>
    <div style="max-width:820px">
      <p class="about-txt-main">Your form has been received and one of our dedicated team members will be in touch with you shortly.</p>
      <p class="about-txt-main mt-68">Lets’ chat soon!</p>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        name:String
    }
}
</script>

<style>
.mail-sent-img{
    width: 119px;
    height: 119px;
}

.mail-sent-img img{
    width: 100%;
    height: 100%;
}

.contact-thanks h1{
    margin: 31px 0;
}

.contact-thanks p{
    padding: 0;
}

.contact-thanks .mt-68{
    margin-top: 68px;
}
</style>